module.exports = __webpack_public_path__ + "img/gold.ab0a2879.png";